<template>
  <div id="use_rule">
    <div id="container">
      <div id="content">
        <div class="title">
          <h2 v-if="dispTitle">利用規約</h2>
          <p>本規約は、ドゥーマンズ株式会社（以下「弊社」といいます。）が提供する｢daros 体験版｣（以下「本サービス」といいます。）の利用に関する規約であり、本サービスを利用するための条件その他の法律関係を定めることを目的とします。なお、本サービスの利用者（以下「利用者」といいます。）は、規約を遵守して本サービスを利用するものとし、利用規約に同意できない場合、本サービスの利用はできません。</p>
        </div>
        <section class="terms_sec">
          <h3>第1条（目的）</h3>
          <ol>
            <li>本サービスは、弊社がコンピュータネットワーク経由で提供する｢daros｣（以下「製品版サービス」といいます。）の試用及び評価のために、弊社が無償で提供するサービスです。</li>
            <li>弊社は、利用者に対して、本サービスの利用を本規約に基づき非独占的、かつ、再許諾及び譲渡不可能なものとして許諾します。</li>
            <li>利用者は、製品版サービスの試用及び評価以外の目的で、本サービスを利用することはできません。</li>
            <li>本サービスの内容は、製品版サービスの一部の機能及びユニット数を制限したものであり、弊社は本サービスの内容をいつでも変更できるものとします。利用者は、本サービスの内容及び内容の変更について、異議を申し述べることはできません。</li>
            <li>利用者は、自らが本サービスの利用により生成した成果物（以下「成果物」といいます。）については、第５条又は第７条の規定にかかわらず、これを利用することができるものとします。</li>
          </ol>
        </section>
        <section class="terms_sec">
          <h3>第2条（本規約の変更）</h3>
          <ol>
            <li>弊社は、本規約をいつでも変更できるものとします。弊社が本規約を変更した場合には、利用者に当該変更内容を通知するものとし、当該変更内容の通知後、利用者が本サービスを利用した場合、又は弊社の定める期間内に解約手続をとらなかった場合には、利用者は、本規約の変更に同意したものとみなします。</li>
          </ol>
        </section>
        <section class="terms_sec">
          <h3>第3条（申込み）</h3>
          <ol>
            <li>本サービスの利用希望者（以下「利用希望者」といいます。）は、本規約に同意した上で、弊社所定のユーザー登録を行うことにより、本サービスの利用申込みをすることができます。</li>
            <li>ユーザー登録は、利用希望者本人が正確な情報を入力するものとします。弊社は、誤った情報を入力したことによる損害について一切の責任を負いません。</li>
            <li>第１項の申込みの時点をもって、弊社と利用希望者との間で本規約に基づく本サービスの利用契約（以下「本契約」といいます。）が成立したものとみなします。本契約の成立により、利用希望者は利用者の地位を取得し、本サービスの利用が許諾されるものとします。</li>
            <li>前項にかかわらず、弊社は、利用希望者が次の各号のいずれかに該当する場合、利用申込みを承諾しない場合があります。この場合、弊社は、弊社所定の方法により利用希望者にその旨を通知するものとし、利用希望者は、それに対して異議を申し述べることはできないものとします。
              <ul>
                <li>(1) 既にユーザー登録がなされている場合</li>
                <li>(2) 過去に本規約その他の弊社が定める規約に違反したことがある場合</li>
                <li>(3) ユーザー登録の内容に正確ではない情報又は虚偽の情報が含まれている場合</li>
                <li>(4) 本サービスの提供を妨害する行為を行うおそれがあると弊社が判断した場合</li>
                <li>(5) 弊社に対する金銭債務の支払を怠ったことがある場合</li>
                <li>(6) 暴力団員、暴力団準構成員、総会屋、社会運動等標榜ゴロ、特殊知能暴力集団構成員その他これに準じる反社会的勢力の構成員（以下「反社会的勢力等」といいます。）であると判明した場合、又は反社会的勢力等が経営に実質的に関与している法人の役員、従業員である等反社会的勢力等と何らかの関係を有していると判明した場合</li>
                <li>(7) その他弊社が不適当であると判断する場合</li>
              </ul>
            </li>
          </ol>
        </section>

        <section class="terms_sec">
          <h3>第4条（ユーザーＩＤ及びパスワードの管理）</h3>
          <ol>
            <li>利用者は、本サービスのユーザーＩＤ及びパスワードを自己の責任において適切に管理するものとし、これを第三者に利用させ、又は譲渡、貸与、担保供与、名義変更その他の処分をしてはならないものとします。</li>
            <li>ユーザーＩＤ及びパスワードの管理不十分による情報の漏洩、使用上の過誤、第三者の使用、不正アクセス等による損害の責任は利用者が負うものとし、弊社は一切責任を負わないものとします。ユーザーＩＤ又はパスワードが不正に利用されたこと等により、弊社に損害が生じた場合、利用者は当該損害を賠償するものとします。</li>
            <li>ユーザーＩＤ及びパスワードの情報が第三者に漏洩した場合又はそのおそれがある場合、利用者は、速やかに弊社に報告するとともに、弊社の指示がある場合にはこれに従うものとします。</li>
          </ol>
        </section>
        <section class="terms_sec">
          <h3>第5条（本契約の解約）</h3>
          <ol>
            <li>利用者は、弊社所定の解約手続きを行うことにより、いつでも本契約を解約することができるものとします。</li>
            <li>利用者は、弊社所定の手続きを行うことにより、製品版サービスへの移行を行うことができます。この場合、本契約は自動的に解約されるものとします。</li>
          </ol>
        </section>
        <section class="terms_sec">
          <h3>第6条（会員資格の取消）</h3>
          <ol>
            <li>弊社は、利用者が次の各号のいずれかに該当すると弊社が判断した場合、事前の通知なしに、本契約を解除することができるものとします。
              <ul>
                <li> (1) 法令又は本規約に違反した場合</li>
                <li> (2) 不正行為があった場合</li>
                <li> (3) ユーザー登録の情報が虚偽であると弊社が判断した場合</li>
                <li> (4) 本規約に必要となる手続又は弊社への報告を行わなかった場合</li>
                <li> (5) ユーザー登録の情報が既存のユーザー登録情報と重複している場合</li>
                <li> (6) 登録した電話番号又はメールアドレスが不通になったことが判明した場合</li>
                <li> (7) 債務超過、無資力、支払停止又は支払不能の状態に陥った場合</li>
                <li> (8) 破産手続開始、民事再生手続開始、会社更生手続開始、特別清算開始もしくはその他適用ある倒産手続開始の申立が行われた場合又は解散もしくは営業停止状態である場合</li>
                <li> (9) 過去に本規約に違反し本サービスの利用停止処分となった者である場合</li>
                <li> (10) 他の利用者や第三者に不当に迷惑をかけた場合</li>
                <li> (11) 自ら又は第三者をして、暴力的な要求行為、法的な責任を超えた不当な要求行為、脅迫的な言動又は暴力を用いる行為、風評を流布し、偽計を用い又は威力を用いて、弊社の信用を毀損又は業務を妨害する行為をした場合</li>
                <li> (12) その他弊社が相応しくないと判断した場合</li>
              </ul>
            </li>
            <li>当社は、本条の措置を受けた者に対し、将来にわたって弊社が提供するサービスの利用を禁止することができるものとします。</li>
            <li>弊社は、本条の措置により生じる不利益及び損害について、一切の責任を負わないものとします</li>
          </ol>
        </section>
        <section class="terms_sec">
          <h3>第7条（本サービスの中断等）</h3>
          <ol>
            <li>弊社は、次の各号のいずれかに該当する場合には、一時的に本サービスの全部又は一部を中断することができるものとします。その際、利用者に損害が発生した場合であっても、弊社は一切の責任を負わないものとします。
              <ul>
                <li> (1) サーバー、通信回線、その他の設備の故障、障害の発生又はその他の理由により本サービスの提供ができなくなった場合</li>
                <li> (2) システム（サーバー、通信回線や電源、それらを収容する建築物などを含む）の保守、点検、修理、変更を定期的に又は緊急に行う場合</li>
                <li> (3) 火災、停電等により本サービスの提供ができなくなった場合</li>
                <li> (4) 地震、噴火、洪水、津波等の天災により本サービスの提供ができなくなった場合</li>
                <li> (5) 戦争、変乱、暴動、騒乱、労働争議等その他不可抗力により本サービスの提供ができなくなった場合</li>
                <li> (6) 法令又はこれに基づく措置により本サービスの提供ができなくなった場合</li>
                <li> (7) その他、運用上又は技術上弊社が本サービスの一時的な中断を必要と判断した場合</li>
              </ul>
            </li>
            <li>弊社は、任意の理由により、利用者への事前通知をすることなく、いつでも本サービス及び本契約の全部又は一部を終了及び変更できるものとします。弊社は、本サービス及び本契約の終了及び変更による損害について、利用者及び第三者に対して一切責任を負わないものとします。</li>
          </ol>
        </section>
        <section class="terms_sec">
          <h3>第8条（知的財産権等）</h3>
          <ol>
            <li>本サービスを構成するシステム、プログラム、ソースコード、コンテンツ、データベースその他本サービスに関連又は付随するデータ、文書、情報等にかかる特許権、著作権、商標権、ノウハウその他の知的財産権を含む一切の権利（以下「知的財産権等」といいます。）は、弊社に帰属します。</li>
            <li>利用者は、本サービスの利用に関して、本規約に定めるほか何らの知的財産権等を取得することはないものとし、本サービスの知的財産権等を侵害してはならないものとします。本規約に基づく本サービスの利用の許諾は、本サービスに関する弊社の権利の使用許諾を意味するものではありません。</li>
            <li>利用者が本サービスにより生成した成果物、データ等に関する一切の責任は、当該利用者が負うものとし、弊社は、その内容、品質、正確性、信憑性、適法性、最新性、有用性等について、一切確認及び保証せず、一切責任を負わないものとします。</li>
            <li>弊社は本サービスに関するコンテンツ、データ等のバックアップを行う義務を負わないものとします。利用者は、コンテンツ、データ等のバックアップが必要な場合には、自己の費用と責任でこれを行うものとします。</li>
          </ol>
        </section>
        <section class="terms_sec">
          <h3>第9条（情報の利用及び提供）</h3>
          <ol>
            <li>弊社は、本サービスの利用にあたり、利用者が提供し、入力し又は登録したあらゆる情報（以下「本情報」といいます。）を、弊社が本サービス及び製品版サービスの向上その他の弊社の事業運営の目的のために集計、解析又は利用することができることに同意するものとします。</li>
            <li>弊社は、本情報について、利用者に関する情報であるとの特定又は識別が可能な情報を含めない形に加工した上、これを第三者に提供することができるものとし、乙はこれに同意するものとします。</li>
          </ol>
        </section>
        <section class="terms_sec">
          <h3>第10条（個人情報等の取扱い）</h3>
          <ol>
            <li>弊社は、本規約のほか、個人情報保護法に従い利用者の個人情報等を取り扱うものとします。</li>
            <li>弊社は、本サービスの提供及び本規約に基づき弊社が取得する個人情報等に関して、次の各号に定める目的で利用することができるものとします。
              <ul>
                <li> (1) 本サービスを提供するため</li>
                <li> (2) 本サービスを維持、改善するため</li>
                <li> (3) 本サービスに関する案内、問い合わせ等への対応のため</li>
                <li> (4) 本規約に違反する行為に対応するため</li>
                <li> (5) 本規約の変更などを通知するため</li>
                <li> (6) 本サービスおよび弊社（弊社子会社を含む。以下同じ。）が提供するサービスの改善に利用するため</li>
                <li> (7) 弊社製品の広告宣伝またはマーケティングのため</li>
                <li> (8) その他各号の利用目的に付随する利用目的のため</li>
              </ul>
            </li>
            <li>弊社は、法令に基づく場合又は以下の各号に定める場合を除き、個人情報等を第三者に預託又は提供する場合は、事前に利用者の同意を得ることなしにこれを行いません。
              <ul>
                <li> (1) 前項の利用目的の達成に必要な範囲において個人情報の取扱いの全部または一部を委託する場合</li>
                <li> (2) 合併その他の事由による事業の承継に伴って個人情報を提供する場合</li>
                <li> (3) 国の機関もしくは地方公共団体またはその委託を受けたものが、法令の定める事務を遂行することに対して協力する必要がある場合</li>
                <li> (4) 個人情報保護法その他の法令で認められる場合</li>
                <li> (5) 利用者又は第三者からの照会があり、かつ、利用者又は第三者の正当な権利行使のために、弊社が開示を必要と判断した場合</li>
                <li> (6) その他プライバシーポリシーに定める場合</li>
              </ul>
            </li>
            <li>個人情報等を前項に基づき第三者に預託又は提供したことによる利用者の損害について、弊社は一切責任を負わないものとします。利用者は、本条の内容を十分に認識した上で、本サービスを利用するものとします。</li>
            <li>弊社は、利用者が本サービスに入力した個人情報等について、関連法規に従い、事実確認を行った上で、訂正、削除又は利用停止等の適切な措置を講じるものとし、この場合、利用者は当該措置に異議申立てを行えないものとします。</li>
          </ol>
        </section>
        <section class="terms_sec">
          <h3>第11条（インターネット接続環境）</h3>
          <ol>
            <li>本サービスの提供を受けるために必要なコンピュータ、ソフトウェア、通信回線その他の機器等（以下「機器等」といいます。）は、利用者の費用と責任において準備し維持するものとします。弊社は、本サービスがあらゆる機器等に適合することを保証するものではなく、機器等の準備、設置、操作に関し一切関与せず、利用者に対するサポートも行いません。</li>
            <li>利用者がインターネット回線を通じて行う本サービスへの入力その他の手続は、弊社のサーバーに当該手続に関するデータが送信され、弊社のシステムに当該手続の内容が反映された時点をもって有効に成立するものとします。</li>
          </ol>
        </section>
        <section class="terms_sec">
          <h3>第12条（禁止事項等）</h3>
          <ol>
            <li>利用者は、本サービスを利用するにあたり、次の各号の行為をし、又はしようとしてはならないものとします。
              <ul>
                <li> (1) 本規則又は法令に違反する行為 </li>
                <li> (2) 本サービスへの不正アクセス行為 </li>
                <li> (3) 本サービスの破壊行為（過度な負担、ウィルス等による破壊を含む。） </li>
                <li> (4) 本サービスの複製、解析、改変、頒布、公衆送信、送信可能化その他の弊社の知的財産権等を侵害する行為 </li>
                <li> (5) 本サービスのソースコード等に対して逆アセンブル、逆コンパイル及びリバースエンジニアリング等を行う行為 </li>
                <li> (6) その他弊社が不適切と判断する行為 </li>
              </ul>
            </li>
            <li>利用者が前項の禁止行為を行ったと弊社が判断した場合、弊社は、当該利用者に対する事前の通知なしに、本サービスの全部又は一部の利用停止その他の弊社が必要と判断する措置を講じることができるものとします。</li>
            <li>前項の措置を講じたことによる利用者の損害又は不利益について、弊社は一切の責任を負わないものとします。</li>
            <li>利用者が第１項の禁止行為を行ったことにより弊社に損害を与えた場合には、弊社に対してその一切の損害を賠償するものとします。</li>
          </ol>
        </section>
        <section class="terms_sec">
          <h3>第13条（非保証及び免責事項）</h3>
          <ol>
            <li>弊社は、本サービスの内容、品質、水準及びサービスの安定的な提供、並びに本サービスの利用に伴う結果等について、一切保証しません。</li>
            <li>弊社は、本サービスにコンピュータウィルス等有害なものが含まれていないことについて、一切保証しません。</li>
            <li>弊社は、利用者が利用した機器等により利用者又は第三者に生じた損害について、一切責任を負わないものとします。</li>
            <li>弊社は、本サービスへのアクセス不能、利用者の機器等の障害、エラー、バグの発生等について、一切責任を負わないものとします。</li>
            <li>弊社は、コンピュータ、システム、通信回線等の障害により、利用者及び第三者が被った一切の損害（データ消失、システムの中断、不正アクセス等）について、一切責任を負わないものとします。</li>
            <li>弊社は、本サービスを利用した結果から生じた損害（本サービスにより生成された成果物の瑕疵（利用者の意図しない成果物が作成された場合を含む。）や当該成果物に基づき製造された家具の構造上の欠陥、不具合等の損害を含むが、これらに限定されません。）、及び利用者が本サービスに入力又は登録したデータ等の消失について、一切責任を負わないものとします。</li>
            <li>前６項のほか、弊社は、利用者が本サービスを利用するにあたり、次の各号の事項について保証せず、一切の責任を負担しません。
              <ul>
                <li> (1) 本サービスが利用者の利用目的に適合し又は有用であること</li>
                <li> (2) 本サービスに不具合、バグ、瑕疵その他の動作不良がないこと</li>
                <li> (3) 本サービスの稼働及び動作適合性</li>
                <li> (4) 他のサービス及びシステム等との動作適合性</li>
                <li> (5) 利用者の機器等と本サービスとの適合性</li>
                <li> (6) 本サービスの利用による乙の機器等その他周辺機器の摩耗、破損その他の損害</li>
                <li> (7) 本サービスの利用にかかる通信関連費用</li>
                <li> (8) 成果物が第三者の知的財産権等を侵害していないこと</li>
                <li> (9) その他弊社の義務とすることが本規約上明示的に定めのない事項</li>
              </ul>
            </li>
            <li>利用者は、本サービスに起因して利用者に生じた一切の損害（間接損害、派生損害、逸失利益、特別の事情から生じた損害（損害発生につき弊社の予見の有無を問いません。）を含みます。）について、弊社を免責するものとし、金銭賠償その他の請求を行わないことに同意するものとします。</li>
          </ol>
        </section>
        <section class="terms_sec">
          <h3>第14条（守秘義務）</h3>
          <ol>
            <li>利用者は、本サービスの利用にあたり覚知した弊社の一切の情報（公知のものを除く。）を秘密に保持し、これを第三者に開示してはならないものとします。</li>
          </ol>
        </section>
        <section class="terms_sec">
          <h3>第15条（地位の譲渡等）</h3>
          <ol>
            <li>利用者は、本規約に基づく権利、義務及び本規約の契約上の地位の全部又は一部について、これを第三者に譲渡、移転、担保供与、貸与その他の方法により処分してはならないものとします</li>
            <li>弊社が本サービスに係る事業を第三者に譲渡する場合（事業譲渡、会社分割その他本サービスが移転する一切の場合を含みます。）には、当該事業の譲渡に伴い、利用者の本規約に基づく契約上の地位、本規約に基づく権利義務及びユーザー登録に伴い登録された情報その他の情報を、弊社は当該事業の譲受人に譲渡することができるものとし、利用者は、かかる譲渡につき予め承諾するものとします。</li>
          </ol>
        </section>
        <section class="terms_sec">
          <h3>第16条（反社会的勢力の排除）</h3>
          <ol>
            <li>弊社は、反社会的勢力等による本サービスの利用を禁止します。弊社は、利用者が反社会的勢力等に該当すると判断した場合、事前に通知することなく、本サービスの提供を停止することができます。弊社は、これにより利用者に生じた損害や不利益について、一切の責任を負いません。</li>
          </ol>
        </section>
        <section class="terms_sec">
          <h3>第17条（準拠法及び管轄裁判所）</h3>
          <ol>
            <li>本規約は、日本法に基づき解釈されるものとします。</li>
            <li>弊社と利用者との間で生じた紛争については、訴額に応じて東京地方裁判所又は東京簡易裁判所を第一審の専属的合意管轄裁判所とします。</li>
          </ol>
        </section>
        <section class="terms_sec">
          <p class="concluded">
            以上
          </p>
        </section>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'UserRuleDetail',
  components: {
  },
  props: {
    dispTitle: Boolean
  },
  data () {
    return {
    }
  },
  methods: {
  },
  computed: {
  },
  mounted: function () {
    document.getElementById('use_rule').addEventListener('scroll', this.scrollEvent)
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
#container {
  margin-left:auto;
  margin-right:auto;
  padding-bottom: 30px;
}
.title {
  margin: 30px auto 30px 0;
  h2 {
    font-size: 2em;
  }
  label {
    font-weight: bold;
  }
  p {
    margin-top: 10px;
  }
}
.rule_parts {
  #use_rule {
    height: 400px;
  }
  #struct_rule {
    height: 200px;
  }
  #use_rule, #struct_rule {
    background: #ffffff;
    overflow: auto;
    border: solid 1px #ced4da;
    #container {
      width:420px;
      padding-top: 40px;
      #content {
        .title {
          margin: 10px;
          h2 {
            font-size: 1.2em;
            text-align: center;
          }
        }
      }
    }
  }
}
#use_rule, #struct_rule {
  #container {
    padding: 20px 30px;
    padding-top: 80px;
    #content {
      .h3 {
        font-weight: bold;
        font-size: 1.2em;
      }
      .terms_sec{
        font-size:0.85em;
        margin: 30px 0;
        ol {
          margin:10px 0;
          line-height: 1.2;
          li {
            margin-left:20px;
            margin-bottom: 5px;
            ul {
              li {
                margin-left:0px;
                margin-bottom: 5px;
              }
            }
          }
        }
        p {
          font-size: 100%;
          margin: 10px;
          line-height: 1.2;
          font-weight: normal;
        }
      }
      ol {
        margin: 10px 0px;
        line-height: 1.2em;
        li {
          font-size: 100%;
          font-weight: normal;
          margin: 0px 0px 5px 20px;
        }
      }
    }
  }
}
.concluded {
  text-align: right;
  font-weight: normal;
  font-size: 0.85em;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/common/UserRuleDetail.vue